import { Box } from '@mui/material'
import { RoomListItemWithStatus } from './room-list-item-with-status'
import { SearchSection } from '$common/room-list-search/search-section'
import { UserListItemWithStatus } from '$common/user-list-item'
import { MenuIcon } from '$common/icons/menu'
import { useRecentSearchedRooms } from '$logic/room-list/room-list-search.react-hook'
import { t } from '$i18n'
import {
  addToRecentSearch,
  deleteFromRecentSearch,
} from '$logic/room-list/room-list-search.service'
import { showDeleteSearchHistoryConfirmModal } from '$comp/modals/confirmation-dialog'
import { showRemoveMenu } from '$comp/modals/menus/remove-menu'
import { openUserProfile } from '$logic/router'

export function LastSearchedChats() {
  const recentSearchedRooms = useRecentSearchedRooms()

  const onMenu = (item: { id: string; type: 'USER' | 'ROOM' }) => {
    showRemoveMenu({ onRemove: () => deleteFromRecentSearch(item) })
  }

  return (
    <>
      {recentSearchedRooms.length > 0 && (
        <SearchSection
          primaryText={t('chatListSearch.recent')}
          secondaryText={t('chatListSearch.deleteAll')}
          secondaryAction={showDeleteSearchHistoryConfirmModal}
        />
      )}

      <Box sx={{ padding: '5px 0', backgroundColor: 'white' }}>
        {recentSearchedRooms.map(({ id, type }) =>
          type === 'USER' ? (
            <UserListItemWithStatus
              key={id}
              userId={id}
              SecondaryActionIcon={MenuIcon}
              onSecondaryActionIconClick={() => onMenu({ type, id })}
              onClick={() => {
                openUserProfile(id)
                addToRecentSearch({ type, id })
              }}
            />
          ) : type === 'ROOM' ? (
            <RoomListItemWithStatus
              key={id}
              roomId={id}
              onSecondaryActionIconClick={() => onMenu({ type, id })}
            />
          ) : null,
        )}
      </Box>
    </>
  )
}
